module.exports = __webpack_public_path__ + "static/media/19GalleryPuppets.39ad88d4.jpeg";